import AdminProductCreateCard from './AdminProductCreateCard';

export default AdminProductCreateCard;
